import request from '../../utils/request'
const urlParams = process.env.VUE_APP_UPLOAD_REAL_PATH
export default {
  //数据看板
  // 设备巡检  
  devicePatrolCensus(data) {
    const params = data
    return request({
      url: urlParams + '/base-data/devicePatrolCensus',
      type: 'get',
      params: params
    })
  },    
  // 工单情况 
  orderWorkCensus(data) {
    const params = data
    return request({
      url: urlParams + '/base-data/orderWorkCensus',
      type: 'get',
      params: params
    })
  },  
  // 工单占比图 
  orderWorkProportion(data) {
    const params = data
    return request({
      url: urlParams + '/base-data/orderWorkProportion',
      type: 'get',
      params: params
    })
  }, 
  // 业主满意率统计 
  ownerSatisfyCensus(data) {
    const params = data
    return request({
      url: urlParams + '/base-data/ownerSatisfyCensus',
      type: 'get',
      params: params
    })
  },  
  // 巡更统计
  patrolCensus(data) {
    const params = data
    return request({
      url: urlParams + '/base-data/patrolCensus',
      type: 'get',
      params: params
    })
  }, 
  // 基本数据详情
  baseDetail(data) {
    const params = data
    return request({
      url: urlParams + '/base-data/detail',
      type: 'get',
      params: params
    })
  },  
  // 基本数据详情-总
  generalDetail(data) {
    const params = data
    return request({
      url: urlParams + '/base-data/generalDetail',
      type: 'get',
      params: params
    })
  },    
  // 缴费统计
  baseBillCensus(data) {
    const params = data
    return request({
      url: urlParams + '/base-data/billCensus',
      type: 'get',
      params: params
    })
  },   
  // 看板新增-修改
  baseaddUp(data) {
    const params = data
    return request({
      url: urlParams + '/base-data/addUp',
      type: 'post',
      params: params
    })
  },     
  //字典管理
  dictGetInfo(data) {
    const params = data
    return request({
      url: urlParams + '/dict/getInfo',
      type: 'get',
      params: params
    })
  }, 
  //设置字典
  dictSetInfo(data) {
    const params = data
    return request({
      url: urlParams + '/dict/setInfo',
      type: 'post',
      params: params,
      qs:false
    })
  },
  //积分明细
  userIntegralsRecordGetList(data) {
    const params = data
    return request({
      url: urlParams + '/user-integrals-record/getList',
      type: 'get',
      params: params
    })
  },     
  //加减积分
  userIntegralsRecordUpdIntegrals(data) {
    const params = data
    return request({
      url: urlParams + '/user-integrals-record/updIntegrals',
      type: 'post',
      params: params,
      qs:false
    })
  },
}